








import Vue from "vue";
export const TextType = Object.freeze({
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  subTitle: "subTitle",
  text: "text",
  small: "small"
});
export const TextColorType = Object.freeze({
  highlight: "#c5ab80",
  black: "#0a0a16",
  white: "#fff",
  inherit: "inherit"
});

export default Vue.extend({
  name: "MobileText",
  props: {
    type: {
      validator(value: any) {
        return Object.values(TextType).includes(value);
      },
      default: TextType.text
    },
    underline: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    color: {
      validator(value: any) {
        return Object.keys(TextColorType).includes(value);
      },
      default: TextColorType.inherit
    }
  },
  methods: {
    getColor(name: any) {
      return TextColorType[name as keyof typeof TextColorType];
    }
  }
});
